<template>
  <operations-table entity="curator" />
</template>

<script>
import OperationsTable from '@/components/AdminOperations/OperationsTable.vue'
export default { name: 'LFAdminCurators', components: { OperationsTable } }
</script>
